import { PrimaryInput } from "common";

import * as S from "../styled";

export const EvidenceSidebarDates = ({ dates, datesValues, subjectProperty, handleDateChange }) => {
  const prevYear = new Date().getFullYear() - (subjectProperty.county === "Dallas" ? 2 : 1);
  const defaultDate = `${prevYear}-01-01`;

  return dates?.map((date) => (
    <S.DatesContent key={`${date.name}-${Math.random()}`}>
      <S.Border />
      <S.Block className="block">
        <S.DateHeader>
          <S.DateTitle>{date.name}</S.DateTitle>
          <S.Description>
            {subjectProperty?.[date.description] ? subjectProperty?.[date.description] : null}
          </S.Description>
        </S.DateHeader>
        <PrimaryInput
          defaultValue={datesValues[date.description] || defaultDate}
          type="date"
          onChange={(e) => handleDateChange(e, date.description)}
        />
      </S.Block>
      <S.Border />
    </S.DatesContent>
  ));
};
